import Swiper from 'swiper/bundle';

const rsCarousel = {
    init: (carousels) => {
        carousels.forEach(carousel => {
            const swiperOptions = {};
            const loop = carousel.dataset.loop;
            const autoplay = carousel.dataset.autoplay;
            const pagination = carousel.dataset.pagination;
            const navigation = carousel.dataset.navigation;

            if (loop) {
                swiperOptions.loop = true;
            }

            if (autoplay) {
                swiperOptions.autoplay = {
                    delay: 6000,
                    disableOnInteraction: false,
                };
            }

            if (pagination) {
                swiperOptions.pagination = {
                    el: '.swiper-pagination',
                    clickable: true,
                };
            }

            if (navigation) {
                swiperOptions.navigation = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                };
            }

            // eslint-disable-next-line no-unused-vars
            const swiper = new Swiper(`#${carousel.getAttribute('id')}`, swiperOptions);
        });
    },
};

export default rsCarousel;
